import { Field, Text } from '@components'
import type { ParentComponent } from 'solid-js'
import { Flex } from 'styled-system/jsx'

export const OptionalField: ParentComponent = (props) => {
	return (
		<Flex justifyContent="space-between">
			<Field.Label class="field__label">{props.children}</Field.Label>
			<Text
				size="xs"
				children="optional"
			/>
		</Flex>
	)
}
